import { t } from 'i18next';
import styled from 'styled-components';

import Modal from '../../../../../components/Modal';
import { RequiredField } from '../../../../../types/apiResponse/form';

type Props = {
  requiredFields: RequiredField[];
  onClose: () => void;
};

const RequiredItemContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;

  .ball {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 8px;
    background-color: red;
  }
`;

const FormRequiredFieldsModal = ({ requiredFields, onClose }: Props) => (
  <Modal
    title={`${t('requiredFields')}`}
    showModal
    closeModal={onClose}
    cancelButton={onClose}
    onlyCloseButton
    bodyStyle={{ overflowX: 'scroll' }}
  >
    <div style={{ margin: '1rem' }}>
      {requiredFields.map((requiredField) => {
        return (
          <RequiredItemContainer key={requiredField.value}>
            <div className="ball" />
            <div>{`${requiredField.label} (${t(requiredField.target)})`}</div>
          </RequiredItemContainer>
        );
      })}
    </div>
  </Modal>
);

export default FormRequiredFieldsModal;
